/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pl_Action_Error_RejectInputs */

const vi_pl_action_error_reject = /** @type {(inputs: Pl_Action_Error_RejectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Từ chối phiếu thất bại`)
};

/**

* @param {Pl_Action_Error_RejectInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pl_action_error_reject = /** @type {((inputs?: Pl_Action_Error_RejectInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pl_Action_Error_RejectInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pl_action_error_reject(inputs)
});